<app-loader *ngIf="showLoader"></app-loader>
<div class="otp-verifications">
    <div class="inner-wrapper">
        <form class="form-field" [formGroup]="otpForm" novalidate>
            <div class="header-wrraper">
                <h3>OTP Verification</h3>
            </div>

            <p>We have sent an OTP on your mobile number and registered email address.</p>
            <div class="otp-box-wrap">
                <label id="dialogOtpLabel"> ENTER OTP </label>
                <div>
                  <!-- Visual timer display -->
                  <span class="resend-otp" *ngIf="this.play" role="timer" aria-hidden="true">
                    <span class="otp-time">{{ mins }}:{{ secs }}</span>
                  </span>
                  <!-- Screen reader announcement at specific intervals -->
                  <div role="status" aria-live="polite" aria-atomic="true">
                    <span class="sr-only">{{ timerAnnouncement }}</span>
                  </div>
                  <span class="sr-only" *ngIf="!this.play" aria-live="polite">Resend OTP is now available</span>
                </div>
                <button type="button" class="resend-otp-button" *ngIf="!this.play" (click)="resendOTP()">RESEND OTP</button>
            </div>
            <div class="otp-verifications-input">
                <div class="otp-box" role="group" aria-labelledby="dialogOtpLabel" [attr.aria-invalid]="errormsg ? 'true' : null" [attr.aria-describedby]="errormsg ? 'dialogOtpError' : null">
                        <input type="tel" maxlength="1" #otpOne
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                        autocomplete="off" autofocus
                        matInput
                        [(ngModel)]="otpArr[0]"
                        formControlName="otpDigitOne"
                        (keydown)="mpinInput($event, 0)"
                        aria-label="Digit 1 of 6" />
                        <input type="tel" maxlength="1" #otpTwo
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                         autocomplete="off"
                         matInput
                         [(ngModel)]="otpArr[1]"
                         formControlName="otpDigitTwo"
                         (keydown)="mpinInput($event, 1)"
                         aria-label="Digit 2 of 6" />
                        <input type="tel" maxlength="1" #otpThree
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                         autocomplete="off"
                         matInput
                         [(ngModel)]="otpArr[2]"
                         formControlName="otpDigitThree" 
                         (keydown)="mpinInput($event, 2)"
                         aria-label="Digit 3 of 6" />
                         
                         <input type="tel" maxlength="1" #otpFour
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                         autocomplete="off"
                         matInput
                         [(ngModel)]="otpArr[3]"
                         formControlName="otpDigitFour"
                         (keydown)="mpinInput($event, 3)"
                         aria-label="Digit 4 of 6" />
                        <input type="tel" maxlength="1" #otpFive
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                         autocomplete="off"
                         matInput
                         [(ngModel)]="otpArr[4]" 
                         formControlName="otpDigitFive"
                         (keydown)="mpinInput($event, 4)"
                         aria-label="Digit 5 of 6" />
                        <input type="tel" maxlength="1" #otpSix
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                         autocomplete="off"
                         matInput
                         [(ngModel)]="otpArr[5]" 
                         formControlName="otpDigitSix"
                         (keydown)="mpinInput($event, 5)"
                         aria-label="Digit 6 of 6" />
                </div>
            </div>
            <div class="error-box" *ngIf="errormsg" role="alert" id="dialogOtpError">
                <img src="https://images.5paisa.com/login/Error.png" alt="Icon for OTP verification error">
                <span>{{errormsg}}</span>
            </div>
            <button class="btn-dark btn-block" (click)="verifyoptForNominee()" [disabled]="disableBtn" id="btnVerifyOTPMPIN">Verify</button>
        </form>
    </div>
</div>